export type Ticker = {
  name: string;
  price: string;
  change: string;
  absChange: string;
  positive: boolean;
};

export const ticker: Ticker[] = [
  {
    name: "恒生指數",
    price: "26559.95",
    change: "1.21%",
    absChange: "-102.04",
    positive: false,
  },
  {
    name: "上證指數",
    price: "4065.58",
    change: "0.68%",
    absChange: "+20.83",
    positive: true,
  },
  {
    name: "日經指數",
    price: "50253.91",
    change: "0.17%",
    absChange: "+86.81",
    positive: true,
  },
  {
    name: "國際金價",
    price: "4256.40",
    change: "1.29%",
    absChange: "+54.10",
    positive: true,
  },
  {
    name: "美元指數",
    price: "99.472",
    change: "0.08%",
    absChange: "-0.080",
    positive: false,
  },
];

export type NavLink = {
  label: string;
  href: string;
};

// 要聞 / CEO AI / 港聞 / 兩岸消息 / EJ Global now have their own pages under
// /dailynews. 副刊文化 still falls back to a columns subcategory; 專題 to
// /features.
export const primaryNav: NavLink[] = [
  { label: "即時", href: "/live-news" },
  { label: "要聞", href: "/dailynews/headline" },
  { label: "理財投資", href: "/columns/finance" },
  { label: "時事評論", href: "/columns/news" },
  { label: "財經新聞", href: "/finnews" },
  { label: "CEO AI", href: "/dailynews/ceoai" },
  { label: "地產", href: "/property" },
  { label: "港聞", href: "/dailynews/hknews" },
  { label: "兩岸消息", href: "/dailynews/cntw" },
  { label: "EJ Global", href: "/dailynews/international" },
  { label: "副刊文化", href: "/columns/culture" },
  { label: "專欄作者", href: "/columns/authors" },
  { label: "專題", href: "/features" },
  { label: "財富管理", href: "/wealth-management" },
  { label: "信報視頻", href: "/video/finance" },
];

export const hotTopics: NavLink[] = [
  { label: "財政預算案", href: "/features/budget-2026" },
  { label: "比特幣", href: "/features" },
  { label: "公司動向特約專輯", href: "/features" },
  { label: "伊朗局勢", href: "/tags/iran-war" },
  { label: "宏福苑聽證會", href: "/features" },
];
